import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import { useEventTracker } from '@applyboard/ui-utils';
import { ProgramType, useApplication, useApplicationConfiguration, useApplicationPagePermissions, useApplicationMainIntake, useIntakes, useLegacyApplication } from "../../data";
import { getApplicationStatusMessage } from "../../utils";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export function ApplicationPageTracker(_ref) {
  var _mainIntake$seatAvail2, _mainIntake$seatAvail3, _mainIntake$seatAvail4, _legacyApplication$sc, _intakes$find, _intakes$find2;
  var applicationId = _ref.applicationId,
    children = _ref.children;
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var _useLegacyApplication = useLegacyApplication(),
    legacyApplication = _useLegacyApplication.legacyApplication;
  var _useApplicationPagePe = useApplicationPagePermissions(),
    permissions = _useApplicationPagePe.permissions;
  var _useIntakes = useIntakes(),
    intakes = _useIntakes.intakes;
  var _useApplicationConfig = useApplicationConfiguration(),
    applicationConfiguration = _useApplicationConfig.applicationConfiguration;
  var _useApplicationMainIn = useApplicationMainIntake(),
    mainIntake = _useApplicationMainIn.mainIntake;
  var scoreConfig = applicationConfiguration === null || applicationConfiguration === void 0 ? void 0 : applicationConfiguration.applicationSuccessScoreLevels.find(function (score) {
    var _mainIntake$seatAvail;
    return score.level === (mainIntake === null || mainIntake === void 0 ? void 0 : (_mainIntake$seatAvail = mainIntake.seatAvailability) === null || _mainIntake$seatAvail === void 0 ? void 0 : _mainIntake$seatAvail.determination);
  });
  var isInsightsCardVisible = (permissions === null || permissions === void 0 ? void 0 : permissions.view_insights) && mainIntake && scoreConfig && (application.stageId === 'pre-payment' || application.stageId === 'pre-submission' || application.stageId === 'submission');
  var academicProgram = legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Main;
  });
  var eslProgram = legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Esl;
  });
  var _useEventTracker = useEventTracker({
      page: 'Student Application',
      data: {
        applicationId: Number(applicationId),
        studentId: application.student.id,
        applicationStatus: getApplicationStatusMessage(legacyApplication.status, application.paidAt),
        applicationStage: application.stageId,
        insightsCardDisplayed: Boolean(isInsightsCardVisible),
        insightsSuccessScore: isInsightsCardVisible ? mainIntake === null || mainIntake === void 0 ? void 0 : (_mainIntake$seatAvail2 = mainIntake.seatAvailability) === null || _mainIntake$seatAvail2 === void 0 ? void 0 : _mainIntake$seatAvail2.score : undefined,
        insightsSuccessScoreLevel: isInsightsCardVisible ? mainIntake === null || mainIntake === void 0 ? void 0 : (_mainIntake$seatAvail3 = mainIntake.seatAvailability) === null || _mainIntake$seatAvail3 === void 0 ? void 0 : _mainIntake$seatAvail3.determination : undefined,
        insightsSuccessScoreVersion: isInsightsCardVisible ? mainIntake === null || mainIntake === void 0 ? void 0 : (_mainIntake$seatAvail4 = mainIntake.seatAvailability) === null || _mainIntake$seatAvail4 === void 0 ? void 0 : _mainIntake$seatAvail4.successScoreVersion : undefined,
        programLevel: academicProgram === null || academicProgram === void 0 ? void 0 : academicProgram.programLevel,
        schoolName: (_legacyApplication$sc = legacyApplication.school) === null || _legacyApplication$sc === void 0 ? void 0 : _legacyApplication$sc.schoolName,
        schoolGroupId: legacyApplication.schoolGroupId,
        academicIntake: {
          startDate: academicProgram === null || academicProgram === void 0 ? void 0 : academicProgram.intake.startDate,
          submissionDeadline: (_intakes$find = intakes.find(function (intake) {
            return intake.startDate === (academicProgram === null || academicProgram === void 0 ? void 0 : academicProgram.intake.startDate);
          })) === null || _intakes$find === void 0 ? void 0 : _intakes$find.submissionDeadline
        },
        eslIntake: {
          startDate: eslProgram === null || eslProgram === void 0 ? void 0 : eslProgram.intake.startDate,
          submissionDeadline: (_intakes$find2 = intakes.find(function (intake) {
            return intake.startDate === (eslProgram === null || eslProgram === void 0 ? void 0 : eslProgram.intake.startDate);
          })) === null || _intakes$find2 === void 0 ? void 0 : _intakes$find2.submissionDeadline
        }
      }
    }),
    Track = _useEventTracker.Track;
  return _jsx(Track, {
    children: children
  });
}